import { Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

export function Title({ children }: PropsWithChildren) {
  return <Typography sx={{ fontSize: 21, fontWeight: 600 }}>{children}</Typography>;
}
